import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../../environments/environment';

export const authGuard: CanActivateFn = (
  route, 
  state,
  router = inject(Router),
) => {
  if (!localStorage.getItem(environment.accessTokenName)) {
    router.navigate([ 'login' ]);
  }

  return true;
};
